<!--
~  Copyright (c) 2021.
~  This file is part of the Compo B2B application.
~  (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>
~  For the full copyright and license information, please view the LICENSE
~  file that was distributed with this source code.
-->

<ng-template #treeTemplate let-nodes>
  <div>
    <ul class="compo-tree">
      @for (item of nodes; track item) {
        <li>
          <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: item }" />
          @if (item.children && item.children.length > 0 && item.expanded) {
        <ng-container *ngTemplateOutlet="
            treeTemplate;
            context: { $implicit: item.children }
          " />
          }
        </li>
      }
    </ul>
  </div>
</ng-template>

@if (treeData) {
  <ng-container *ngTemplateOutlet="treeTemplate; context: { $implicit: treeData }" />
}
